import { Route, Routes } from 'react-router-dom';
import './App.css';
import About from './Componants/Home/About';
import Bikes from './Componants/Home/Bikes';
import Blogrs from './Componants/Home/Blogrs';
import Contact from './Componants/Home/Contact';
import Home from './Componants/Home/Home';
import ToolsBD from './Componants/Home/ToolsBD';
import Wildlife from './Componants/Home/Wildlife';
import Navbar from './Componants/Navbar';

function App() {
  return (
    <div className="">
      <Navbar></Navbar>
      <Routes>
        <Route path='/' element={<Home></Home>}></Route>
        <Route path='/contact' element={<Contact></Contact>}></Route>
        <Route path='/tools' element={<ToolsBD></ToolsBD>}></Route>
        <Route path='/bikes' element={<Bikes></Bikes>}></Route>
        <Route path='/wildlife' element={<Wildlife></Wildlife>}></Route>
        <Route path='/blogs' element={<Blogrs></Blogrs>}></Route>
        <Route path='/about' element={<About></About>}></Route>
      </Routes>

    </div>
  );
}

export default App;
